import Menu from './Menu'

export default Menu
// eslint-disable-next-line import/export
export * from './Menu'
